/**
 * §7.9 Licensing Terms — 6 crystal-clear clauses.
 */

import React from 'react'
import {
  ServerCog, CalendarRange, RefreshCw, Repeat, ArrowUpRight, FileText, Sparkles,
} from 'lucide-react'
import { Container, Eyebrow, SectionHeading } from '@/components/landing/design-system'
import { TERMS } from '../data'
import { TONE } from '../_shared'

const ICONS = { ServerCog, CalendarRange, RefreshCw, Repeat, ArrowUpRight, FileText }

export default function Terms() {
  return (
    <section className="relative py-24 md:py-28">
      <Container size="wide" className="flex flex-col gap-10">
        <div className="flex flex-col items-center text-center gap-5 max-w-3xl mx-auto">
          <Eyebrow>Licensing Terms</Eyebrow>
          <SectionHeading align="center"
            title={<>Licensing that&apos;s{' '}<span className="bg-gradient-to-r from-brand-gold to-[#FFE17A] bg-clip-text text-transparent">simple and predictable.</span></>}
            subtitle="Six clauses cover the entire commercial relationship. No hidden fees. No surprise renewals. No punitive termination."
          />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {TERMS.map((t, i) => {
            const tone = TONE[t.tone] || TONE.orange
            const Icon = ICONS[t.iconKey] || Sparkles
            return (
              <div key={t.id} className="relative rounded-2xl border border-white/10 bg-white/[0.02] p-5 backdrop-blur-xl transition-all hover:border-white/20 hover:bg-white/[0.03] overflow-hidden">
                <div className="pointer-events-none absolute inset-0 opacity-40"
                  style={{ background: `radial-gradient(80% 40% at 20% 0%, rgba(${tone.rgb},0.10), transparent 70%)` }} />
                <div className="relative flex items-start gap-3">
                  <span className="inline-flex h-9 w-9 items-center justify-center rounded-xl border shrink-0"
                    style={{ borderColor: `rgba(${tone.rgb},0.35)`, background: `rgba(${tone.rgb},0.08)`, color: tone.hex }}>
                    <Icon strokeWidth={1.8} style={{ width: 15, height: 15 }} />
                  </span>
                  <div>
                    <div className="flex items-baseline gap-2">
                      <span className="text-[9.5px] font-mono uppercase tracking-wider text-zinc-500">clause {String(i + 1).padStart(2, '0')}</span>
                    </div>
                    <h4 className="text-[14px] font-semibold text-white leading-tight mt-1">{t.label}</h4>
                    <p className="text-[12.5px] text-zinc-400 leading-relaxed mt-1.5">{t.body}</p>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </Container>
    </section>
  )
}
